<div class="button-group">
  <button id="backButton" class="btn btn--true-blue btn--x-large flex-column align-center" [disabled]="!isBackEnabled"
    (click)="onBackButtonClicked($event)">
    <svg class="height-3 width-3 mb1" viewBox="0 0 100 76" id="Back" width="100%" height="100%">
      <title>Back</title>
      <path
        d="M43.734 12.258a7.177 7.177 0 0 0 0-10.156 7.19 7.19 0 0 0-10.16 0L1.406 34.25a4.79 4.79 0 0 0 0 6.781l32.168 32.145a7.182 7.182 0 0 0 10.16 0 7.176 7.176 0 0 0 0-10.152l-18.28-18.27h66.503a7.18 7.18 0 0 0 0-14.36H25.582l18.152-18.136z"
        fill="var(--color)"></path>
    </svg>Back
  </button>
  <button id="homeButton" class="btn btn--true-blue btn--x-large flex-column align-center" #homeButton [disabled]="!isHomeEnabled"
    (click)="onHomeButtonClicked($event)">
    <svg class="height-3 width-3 mb1" viewBox="0 0 100 100" id="Home" width="100%" height="100%">
      <title>Home</title>
      <path
        d="M63.02 6.105c-7.41-8.14-19.53-8.14-26.953 0L4.157 41.156c-7.41 8.141-4.644 14.801 6.152 14.801h6.688v28.25A15.837 15.837 0 0 0 32.79 100h6.968l-.003-33.594h19.578V100H66.3a15.839 15.839 0 0 0 15.79-15.793v-28.25h6.684c10.797 0 13.562-6.66 6.156-14.797L63.02 6.105z"
        fill="var(--color)"></path>
    </svg>Home
  </button>
</div>
